import { useEffect, useRef } from "react";
import { setSettings } from "../support/slices/tileBuilderSlice";
import { arraysEqual } from "../support/utils";
import { RootState, useAppDispatch } from "../support/store";
import { ChartKind } from "../components/Admin/TileBuilder/TilePreview/tilePreviewTypes";
import { useSelector } from "react-redux";
import { initialSettings } from "../types/tileBuilderTypes";


export function useTileFieldInit(chartId: string, chartType: ChartKind, derivedFields: string[]) {
  const dispatch = useAppDispatch();
  const settings = useSelector(
    (state: RootState) => state.tileBuilder[chartId]?.tile.settings || initialSettings
  );

  const isDatagrid = chartType === 'datagrid';
  const isMetric = chartType === 'metric';

  // Track which chartId+kind combos have been initialized
  const initializedRef = useRef<Record<string, boolean>>({});

  const datagridKey = `${chartId}-datagrid`;
  const nonDatagridKey = `${chartId}-${chartType}`;

  useEffect(() => {
    if (isDatagrid && derivedFields.length > 0 && !initializedRef.current[datagridKey]) {
      if (!arraysEqual(settings.selectedColumns || [], derivedFields)) {
        dispatch(setSettings({ chartId, settings: { selectedColumns: derivedFields } }));
      }
      initializedRef.current[datagridKey] = true;
    }
    if (!isDatagrid) {
      initializedRef.current[datagridKey] = false;
    }
  }, [isDatagrid, derivedFields, settings.selectedColumns, dispatch, chartId, datagridKey]);

  useEffect(() => {
    if (!isDatagrid && !isMetric && derivedFields.length > 0 && !initializedRef.current[nonDatagridKey]) {
      const validLabelField = derivedFields.includes(settings.labelField || '')
        ? settings.labelField : derivedFields[0];
      const validValueField =
        derivedFields.includes(settings.valueField || '') || ['Count', 'Sum'].includes(settings.valueField || '')
          ? settings.valueField : 'Count';

      if (validLabelField !== settings.labelField || validValueField !== settings.valueField) {
        dispatch(setSettings({ chartId, settings: { labelField: validLabelField, valueField: validValueField } }));
      }
      initializedRef.current[nonDatagridKey] = true;
    }
    if (isDatagrid) {
      initializedRef.current[nonDatagridKey] = false;
    }
  }, [isDatagrid, isMetric, derivedFields, settings.labelField, settings.valueField, dispatch, chartId, nonDatagridKey]);
}